<script setup lang="ts">
import type { PropType } from 'vue'
import type ContextMenuItem from '../../../type/ContextMenuItem'

const { menuItem, theme } = defineProps({
  menuItem: {
    type: Object as PropType<ContextMenuItem>,
    required: true
  },
  theme: {
    type: Boolean,
    required: false,
    default: false
  }
})
</script>
<template>
  <div w-full flex="~ col" cursor-pointer>
    <div
      :class="[menuItem.isTop ? 'border-t border-light' : '', !theme ? 'context-menu-item' : 'hover:bg-theme-light-80']"
      flex="~ row"
      w-full
      items-center
      py-2.3>
      <i
        v-if="menuItem.icon != undefined"
        :class="[menuItem.icon, menuItem.important ? 'text-danger' : '']"
        ml-4
        text-2xl></i>
      <div mx-3 grow :class="menuItem.important ? 'text-danger' : ''" text-base leading-5>
        {{ menuItem.name }}
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
